export const CUSTOMIZATION_ENUM = {
  WHOLE: 0,
  FLOORS: 1,
  APARTMENTS: 2,
};

export const CUSTOMIZATION_OPTIONS = [
  { value: 0, label: "Întreaga locație" },
  { value: 1, label: "Pe etaje" },
  { value: 2, label: "Pe apartamente" },
];
